<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_SettingValuePriority')"
      width="320px"
      height="400px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner edi-bill-search-selector"
      @close="cancel()"
    >
      <div v-if="innerVisible" class="app-main-inner-row" style="height: 230px">
        <div style="display: flex">
          <el-table
            :data="localValList"
            :show-header="false"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column>
              <template slot-scope="{row}">
                <span>{{ row.name }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex;flex-direction: column;margin-left: 15px">
            <el-button :disabled="!currentVal" type="primary" style="margin-left: 5px;margin-bottom: 5px" @click="moveUp">↑</el-button>
            <el-button :disabled="!currentVal" type="primary" @click="moveDown">↓</el-button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" no="4" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="5" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'WarehouseCodePriorityDialog',
  props: {
    visible: { type: Boolean, required: true },
    valList: { type: Array, default: () => [] } // 取值列表：客户、指定货代理、目的港代理
  },
  data() {
    return {
      innerVisible: false,
      currentVal: null,
      localValList: []
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    valList: {
      async handler(newVal) {
        this.localValList = [...newVal]
      },
      immediate: true
    }
  },
  methods: {
    moveUp() {
      const valList = [...this.localValList]
      for (let i = 0; i < valList.length; ++i) {
        const val = valList[i]
        if (val.code === this.currentVal.code) {
          if (i > 0) {
            valList[i] = valList[i - 1]
            valList[i - 1] = this.currentVal
            this.localValList = [...valList]
          }
          break
        }
      }
    },
    moveDown() {
      const valList = [...this.localValList]
      for (let i = 0; i < valList.length; ++i) {
        const val = valList[i]
        if (val.code === this.currentVal.code) {
          if (i < this.localValList.length - 1) {
            valList[i] = valList[i + 1]
            valList[i + 1] = this.currentVal
            this.localValList = [...valList]
          }
          break
        }
      }
    },
    handleCurrentChange(val) {
      this.currentVal = val
    },
    confirm() {
      this.$emit('confirm', this.localValList)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.currentVal = null
      // 还原
      this.localValList = [...this.valList]
    }
  }
}
</script>

<style lang="scss">

</style>
